<template>
  <v-app>
    <page-header />
     <span class="bg">
        <v-img
          :src="require('./assets/baggrund.png')"
          :lazy-src="require('./assets/baggrund_small.png')"
          width="100%"
          height="100%"
        >
        </v-img>
     </span>
    <v-main  align-center>
      <!-- Provides the application the proper gutter -->
      <v-container fluid fill-height>

        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    /* background: url('./assets/baggrund.png') no-repeat center center;
    background-size: cover; */
    background-color: white;
    /* transform: scale(1.1); */
  }
</style>

<script>
import PageHeader from '@/components/Header.vue'
export default {
  name: 'App',

  components: {
    PageHeader
  },

  data: () => ({
    //
  })
}
</script>
